import type { IconV2Props, MediumIconV2StrokeWidth, SmallIconV2StrokeWidth } from './IconV2.types';

const strokeWidths: Record<IconV2Props['size'], SmallIconV2StrokeWidth | MediumIconV2StrokeWidth> = {
  [16]: 1.2,
  [24]: 1.87,
  [32]: 1.6
};

export const IconV2 = ({ children, size, viewBox, ...forwardProps }: IconV2Props) => (
  <svg {...forwardProps} fill="none" height={size} width={size} viewBox={viewBox} strokeWidth={strokeWidths[size]}>
    {children}
  </svg>
);
